// Sufijo informativo del descuento habitual del cliente.
// SOLO se muestra al admin y SOLO en los selectores de cliente (después del nombre).
// Es puramente informativo: no interviene en ningún cálculo.
export function clientDiscountSuffix(client, isAdmin) {
  if (!isAdmin || !client) return '';
  const d = parseFloat(client.habitualDiscount);
  if (!d || d <= 0) return '';
  // parseFloat quita ceros sobrantes: 5.00 -> "5", 7.50 -> "7.5"
  return ` · ${d}% dto.`;
}

// Muestra el error de un alta de cliente. Si el backend responde que el cliente ya existe pero está
// ARCHIVADO en Odoo (409), el aviso es largo y con instrucciones: se deja 20 segundos en pantalla
// (los avisos normales duran 3) y no se cierra solo al pasar el ratón.
export function mostrarErrorAltaCliente(toast, error, prefijo = '') {
  const datos = error?.response?.data || {};
  if (datos.error === 'CLIENTE_ARCHIVADO_EN_ODOO') {
    toast.warning(datos.message, { autoClose: 20000, pauseOnHover: true, closeOnClick: true });
    return;
  }
  toast.error(prefijo + (datos.message || datos.error || error?.message || 'Error al crear el cliente'));
}

// Aviso tras un alta de cliente. Si el backend NO creó ficha porque ya existía una con ese
// teléfono o nombre (respuesta `reused`, ver api.createClient), se avisa en amarillo y durante
// 10 segundos en vez del "creado" verde de siempre: el operario tiene que enterarse de que se
// está usando otra ficha (p.ej. tecleó "cliente tienda" con un teléfono que ya era de otro).
// Devuelve true si la ficha era reutilizada.
export function avisarAltaCliente(toast, client) {
  if (client?.reused) {
    const motivo = client.reusedMessage || `Ya existe una ficha para "${client.name}"`;
    toast.warning(`${motivo}. No se ha creado otra: se usa la ficha existente.`, { autoClose: 10000, pauseOnHover: true, closeOnClick: true });
    return true;
  }
  toast.success('Cliente creado exitosamente');
  return false;
}

// Nombre + sufijo de descuento (para selectores que usan una cadena plana).
export function clientLabelWithDiscount(client, isAdmin) {
  if (!client) return '';
  return `${client.name}${clientDiscountSuffix(client, isAdmin)}`;
}
